import { render, staticRenderFns } from "./VRSlider.vue?vue&type=template&id=9b0badf4"
import script from "./VRSlider.vue?vue&type=script&lang=js"
export * from "./VRSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports